import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'antd';
import { AssociationsSelector } from 'ui-library';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';

const doNothing = () => {};

// TODO: add tree vs smart groups buttons in the Associations Selector component once Figma file is ready

const AssociationModal = ({
  isVisible = false,
  onSave = doNothing,
  onClose = doNothing,
  operations,
}) => {
  const associationGroupsForm = Form.useFormInstance();
  const associations = Form.useWatch('associations', associationGroupsForm);
  const [selectedData, setSelectedData] = useState([]);

  useEffect(() => {
    setSelectedData(associations);
  }, [associations]);

  const { data: associationOptions } = useQuery({
    queryKey: ['association_options'],
    queryFn: () =>
      apiGet('/landlords/associations').then((response) => {
        // TODO: update this to expect portfolios[] or groups[] as well once the API is updated
        return response?.sites;
      }),
    onError: () => message.error(getTranslatedString('unknownError')),
  });

  const handleSave = () => {
    operations.remove();
    selectedData?.map((item) => operations.add(item));
    onSave();
  };

  return (
    <Modal
      destroyOnClose
      width={1024}
      visible={isVisible}
      title={getTranslatedString('landlordPortal.incentives.associations')}
      onOk={handleSave}
      onCancel={onClose}
    >
      <AssociationsSelector
        selectedRows={selectedData}
        onSelection={setSelectedData}
        smartGroups
        asyncSave
        height="519"
        dataSource={associationOptions}
      />
    </Modal>
  );
};

export default AssociationModal;
